export default __webpack_public_path__ + "static/media/Sign-up-light-business.49792835.svg";